import "./SolarSystem.modules.scss";

import React, { Component } from "react";
import { connect } from "react-redux";

import Planet from "../Planet/Planet";
import { solarSystemConfig } from "../../assets/javascript/constants";

// * Documentation: https://github.com/greensock/GSAP
import gsap from "gsap";
import { isPortrait } from "../../assets/javascript/utils";

class SolarSystem extends Component {
  constructor(props) {
    super(props);

    this.solarSystemRef = React.createRef();
    this.orbitRef = React.createRef();
    this.rocketRef = React.createRef();

    this.state = {
      multiplier: 1,
      activePlanet: -1,
    };

    this.windowSizeChange = this.windowSizeChange.bind(this);
    // this.windowSizeChange = debounce(this.windowSizeChange.bind(this), 500);
  }

  componentDidMount() {
    this.windowSizeChange();
    window.addEventListener("resize", this.windowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.windowSizeChange);
    this.windowSizeChange = null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { activePlanet } = this.props;

    if (prevProps.activePlanet !== activePlanet) {
      this.setState({
        activePlanet: activePlanet,
      });
    }
  }

  windowSizeChange() {
    if (this.solarSystemRef.current) {
      let multiplier = 1;

      if (isPortrait()) {
        const currentHeight = Math.round(
          this.solarSystemRef.current.getBoundingClientRect().height
        );
        multiplier = currentHeight / solarSystemConfig.height;
      } else {
        const currentWidth = Math.round(
          this.solarSystemRef.current.getBoundingClientRect().width
        );
        multiplier = currentWidth / solarSystemConfig.height;
      }

      this.setState({ multiplier: multiplier }, () => {
        this.setOrbit();
      });
    }
  }

  setOrbit() {
    if (isPortrait()) {
      gsap.to(this.orbitRef.current, {
        height: (
          solarSystemConfig.planets[8].x * this.state.multiplier
        ).toFixed(4),
        width: 1,
        duration: 1,
        ease: "expo.out",
        delay: 0.4,
      });
    } else {
      gsap.to(this.orbitRef.current, {
        height: 1,
        width: window.innerWidth - 60,
        duration: 1,
        ease: "expo.out",
        delay: 0.4,
      });
    }
  }

  onPlanetClick(index) {
    this.setState({
      activePlanet: index,
    });
  }

  render() {
    const { multiplier, activePlanet } = this.state;
    const currentPlanet = solarSystemConfig.planets[activePlanet];

    return (
      <div
        className={`solarSystem ${activePlanet === -1 ? "" : "-active"}`}
        ref={this.solarSystemRef}>
        {solarSystemConfig.planets.map((planet, index) => (
          <Planet
            key={index}
            index={index}
            activePlanet={activePlanet}
            data={planet}
            multiplier={multiplier}
            onClick={(index) => {
              this.onPlanetClick(index);
            }}
          />
        ))}

        <span className="line -orbit" ref={this.orbitRef}></span>

        <span
          className="line -rocket"
          ref={this.rocketRef}
          style={{
            height: isPortrait()
              ? activePlanet === -1
                ? 0
                : currentPlanet.size
              : 1,
            left: isPortrait()
              ? "auto"
              : activePlanet === -1
              ? 0
              : currentPlanet.x * multiplier - currentPlanet.size / 2 + 4,
            top: isPortrait()
              ? activePlanet === -1
                ? 0
                : currentPlanet.x * multiplier - currentPlanet.size / 2
              : 1,
            width: isPortrait()
              ? 1
              : activePlanet === -1
              ? 0
              : currentPlanet.size - 8,
          }}></span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activePlanet: state.activePlanet,
  };
};

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(SolarSystem);
